import { fetchProductsInCart } from '../theme-scripts.js';

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (!this.querySelector('[type="submit"]')) return;

        if (document.querySelector('cart-drawer')) this.querySelector('[type="submit"]').setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        // Get product data from JSON element on product page
        const productJsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
        const currentProductType = productJsonData.product.type.toLowerCase();
        const selectedVariantId = productJsonData.selected_variant_id;
        const hasModules = productJsonData?.configuration?.metafields?.configuration_modules?.[selectedVariantId] || {};
        const hasModulesToAdd = hasModules && Object.keys(hasModules).length > 0 ? hasModules : false;

        fetchProductsInCart()
          .then((data) => {
            if (
              (data.swatchProductsLimitReached[0] && currentProductType == window.swatches.productTypeUpholstery) ||
              (data.swatchProductsLimitReached[0] && currentProductType == window.swatches.productTypeMaterial)
            ) {
              const clickEvent = new Event('click');
              const samplesModal = document.querySelector('[data-modal="#PopupModal-Samples"]');
              const stockModal = document.querySelector('[data-stock-modal][open]');
              if (stockModal) {
                stockModal.removeAttribute('open');
              }
              samplesModal.querySelector('button').dispatchEvent(clickEvent);
            } else {
              if (this.querySelector('[type="submit"]').getAttribute('aria-disabled') === 'true') return;

              this.handleErrorMessage();

              this.querySelector('[type="submit"]').setAttribute('aria-disabled', true);
              this.querySelector('[type="submit"]').classList.add('loading');
              this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];

              const formData = hasModulesToAdd ? new FormData() : new FormData(this.form);

              // Call the function to append upsell products to FormData
              this.appendProductRecommendationsToCart(formData);
              if (this.form && typeof this.form.id === 'string' && !this.form.id.includes('MaterialDrawer-')) {
                this.addBuyXGetYProductToCart(formData);
              }
              if (hasModulesToAdd) {
                this.appendProductModulesToCart(formData, productJsonData);
              }

              if (this.cart) {
                formData.append(
                  'sections',
                  this.cart.getSectionsToRender().map((section) => section.id),
                );
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
              }

              config.body = formData;

              fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.querySelector('[type="submit"]').querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.querySelector('[type="submit"]').setAttribute('aria-disabled', true);
                    this.querySelector('[type="submit"]').querySelector('span').classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                  } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                  }

                  if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
                  this.error = false;
                  const modal = this.closest('quick-add-modal') || this.querySelector('[data-stock-modal]');
                  if (modal) {
                    document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                          this.cart.renderContents(response);
                        });
                      },
                      { once: true },
                    );
                    modal.hide(true);
                  } else {
                    this.cart.renderContents(response);
                  }
                })
                .catch((e) => {
                  console.error(e);
                })
                .finally(() => {
                  this.querySelector('[type="submit"]').classList.remove('loading');
                  if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                  if (!this.error) this.querySelector('[type="submit"]').removeAttribute('aria-disabled');
                  this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      appendProductRecommendationsToCart(formData) {
        const productRecommendationsType = document.querySelectorAll('[id^="ProductsRecommendations"]');

        productRecommendationsType.forEach((element, typeIndex) => {
          const productType = element.dataset.productRecommendationsType;
          const selectedVariantIds = Array.from(document.querySelectorAll(`.${productType}-checkbox:checked`)).map((checkbox) => checkbox.dataset.variantId);

          selectedVariantIds.forEach((variantId, index) => {
            const itemIndex = typeIndex * 100 + index + 1; // To be sure that different metafield types dont overlap
            formData.append(`items[${itemIndex}][id]`, variantId);
            formData.append(`items[${itemIndex}][quantity]`, 1);
            formData.append(`items[${itemIndex}][properties][_type]`, productType); // To be able to see customers that buy these products in the backoffice
          });
        });
      }

      appendProductModulesToCart(formData, productJsonData) {
        const productModulesToAdd = document.querySelectorAll('[data-add-configuration-module]');

        productModulesToAdd.forEach((element, index) => {
          const variantId = element.dataset.moduleId;
          const itemIndex = index * 100 + index + 1; // To be sure that different metafield types dont overlap
          formData.append(`items[${itemIndex}][id]`, variantId);
          formData.append(`items[${itemIndex}][quantity]`, 1);
          formData.append(`items[${itemIndex}][properties][Configuration]`, productJsonData.product.title);
          formData.append(`items[${itemIndex}][properties][_configuration_url]`, window.location.href);
        });
      }

      addBuyXGetYProductToCart(formData) {
        const currentVariant = document.querySelector('.product-variant-id').value;

        const productJsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
        const productBuyXGetYJson = productJsonData['configuration']['metafields']['buy_x_get_y'];
        const buyXGetYProductId = productBuyXGetYJson[currentVariant]['get_product'];

        if (currentVariant && buyXGetYProductId > 0) {
          formData.append('items[0][id]', buyXGetYProductId);
          formData.append('items[0][quantity]', 1);
          formData.append('items[0][properties][Campaign]', 'Free');
        }
      }
    },
  );
}
